// extracted by mini-css-extract-plugin
export default {"pageTitle":"tabs_pageTitle__9xt7z","tabs":"tabs_tabs__fOXnl","selected":"tabs_selected__d1wFb","siteWidth":"tabs_siteWidth__JSbAh"};